const production = true;

export const apiUrl = production
  ? "https://api-contact.v3dataintel.com"
  : "http://localhost:5010";



// export const apiUrl = production
//   ? "https://v3.tzes.in:5007"
//   : "http://localhost:5010";